<template>
  <div class="verify-group">
    <v-container class="pa-3 pt-5">
      <template v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </template>
      <div v-else>
        <p class="my-3 text-body-2">グループ招待の認証が完了しました。</p>
        <p class="my-3 text-body-2">トップに戻ってログインしてください。</p>
        <v-btn @click="gotoTopClick">
          トップに戻る
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import * as authApi from '../api/modules/auth';
import { isSuccessStatus } from '../utils/http';

export default {
  data: () => ({
    loading: true,
    tm: null,
  }),
  computed: {},
  methods: {
    gotoTopClick() {
      if (this.tm) {
        clearInterval(this.tm);
      }
      this.$store.dispatch('error/clearError');
      window.location = '/';
    },
  },
  async created() {
    const result = await authApi.verifyGroupByToken(this.$route.params.token);

    if (isSuccessStatus(result.statusCode)) {
      this.tm = setTimeout(() => {
        this.$store.dispatch('error/clearError');
        window.location = '/';
      }, 10000);
    } else {
      this.$store.dispatch(
        'error/setError',
        {
          code: result.statusCode,
          id: result.requestId,
          message: result.response,
        },
        { root: true },
      );
    }
    this.loading = false;
  },
};
</script>
